'use strict';

define('recaptcha', [], function () {
    const data_sitekey = config['recaptcha:siteKey'];
    return function () {
        const recaptcha = {};
        const watchers = [];
        recaptcha.$el = null;
        recaptcha.isInit = false;
        recaptcha.isRegisterOnWindow = false;
        recaptcha.isRender = false;
        let destroyed = false;

        recaptcha.init = function (parentEl, doRender) {
            recaptcha.$parentEl = (
                () => {
                    if (parentEl instanceof jQuery) {
                        return parentEl;
                    }
                    if (parentEl instanceof HTMLElement) {
                        return $(parentEl);
                    }
                    return $(document);
                }
            )();
            recaptcha.$el = parentEl.find('.g-recaptcha');
            if (!recaptcha.$el[0]) {
                console.error(`No reCAPTCHA clients exist!`)
            }
            if (doRender) {
                recaptcha.render();
            }
            return this;
        };

        recaptcha.render = function () {
            if (recaptcha.isRender) {
                return;
            }
            if (recaptcha.$el.hasClass('hidden')) {
                recaptcha.$el.removeClass('hidden');
            }
            initGrecaptcha().then(
                // 已初始化
                () => {
                    recaptcha.opt_widget_id = window.grecaptcha.enterprise.render(recaptcha.$el[0], {
                        sitekey: data_sitekey,
                        callback,
                    });

                    recaptcha.isRender = true;
                },
                // 谷歌 js 尚未加载完毕
                () => {
                    app.alertError('reCAPTCHA component init error');
                }
            )
        };

        recaptcha.reset = function () {
            if (recaptcha.isRender) {
                window.grecaptcha.enterprise.reset(recaptcha.opt_widget_id);
            }
            return this;
        };

        recaptcha.destroy = function () {
            if (!recaptcha.isRender) {
                console.error('reCAPTCHA component never render');
                return;
            }
            if (!recaptcha.$el.hasClass('hidden')) {
                recaptcha.$el.addClass('hidden');
            }
            if (!destroyed) {
                recaptcha.render = function () {
                    window.grecaptcha.enterprise.reset(recaptcha.opt_widget_id);
                    if (recaptcha.$el.hasClass('hidden')) {
                        recaptcha.$el.removeClass('hidden');
                    }
                };
                destroyed = true;
            }
        };

        recaptcha.getResponse = function (id) {
            if (arguments.length === 0 || id === void 0) {
                id = recaptcha.opt_widget_id;
            }
            return window.grecaptcha.enterprise.getResponse(id);
        };

        recaptcha.onVerified = function (fn) {
            watchers.push(fn);
            return this;
        };

        return recaptcha;

        function initGrecaptcha() {
            return new Promise((resolve, reject) => {
                if (recaptcha.isInit) {
                    resolve();
                    return;
                }
                if (checkIsRegistedOnWindow()) {
                    window.grecaptcha.enterprise.ready(() => {
                        recaptcha.isInit = true;
                        resolve();
                    });
                    return;
                }
                reject()
            })
        }

        function checkIsRegistedOnWindow() {
            if (recaptcha.isRegisterOnWindow) {
                return true;
            }
            if (window.grecaptcha) {
                recaptcha.isRegisterOnWindow = true;
                return true;
            }
            return false;
        }

        function callback() {
            watchers.forEach(fn => fn.apply(this, arguments));
        }
    }
})